/* eslint-disable */

import { normalize } from 'polished';
import { createGlobalStyle } from 'styled-components';
import theme from './theme';
import typography from './typography';

const MobileStyle = createGlobalStyle`
  ${normalize()}

  html {
    font-size: 14px;
  }

  body {
    background: #0E1124;
  }

  *:not(body, html) {
    ${typography.MobileUIText} 
    transition: all ${theme.transitionTime.quick};
    line-height: ${theme.typography.mobileParagraphLineHeight};
  }
  *{
    -ms-overflow-style: none;
  }
  :not(.visible-scrollbar)::-webkit-scrollbar {
    display: none;
  }
  .visible-scrollbar::-webkit-scrollbar {
    display: block;
    width: 10px;
    height: 10px;
    background-color: transparent;
    -webkit-overflow-scrolling: auto
  }
  .visible-scrollbar::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  .visible-scrollbar::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  .visible-scrollbar::-webkit-scrollbar-thumb {
    background-color: #a63638;
    border-radius: 5px;
  }

  h1 { ${typography.heading1} }
  h2 { ${typography.heading2} }
  h3 { ${typography.heading3} }
  h4 { ${typography.heading4} }
  h5 { ${typography.heading5} }
  h6 { ${typography.heading6} }

  p, p * { ${typography.paragraph} }

  h1, h2, h3, h4, h5, h6, p {
    margin-bottom: ${theme.spacing.x2};
    margin-top: ${theme.spacing.x2};

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: ${theme.color.secondaryDark};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  // accessibility options
  *:focus-visible{
    outline: 2px #000 solid;
    outline-style: auto;
  }

  // react modal
  .ReactModal__Overlay {
    opacity: 0;
    transition: all 300ms ease-in-out;
  }
  .rs-container {
    min-width: 115px;
  }
  .ReactModal__Content {
    opacity: 0;
    transform: translateX(100px);
    transition: all 300ms ease-in-out;
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;
  }

  .ReactModal__Overlay--before-close {
    opacity: 0;
  }
  
  .ReactModal__Content--after-open {
    opacity: 1;
    transform: translateX(0px);
  }

  .ReactModal__Content--before-close {
    opacity: 0;
    transform: translateX(100px);
  }
`;

export default MobileStyle;
